(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aspira-journy"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ajInit) return; root.dataset.ajInit = "1";
    var timeline = root.querySelector("[data-timeline]");
    var track = root.querySelector("[data-track]");
    var progress = root.querySelector("[data-progress]");
    var nodes = Array.prototype.slice.call(root.querySelectorAll("[data-node]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-card]"));
    if (!timeline || !nodes.length) return;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var animate = root.classList.contains("aspira-journey--animated") && !reduce;
    var top = 0, span = 1;
    function layout() {
      var t = timeline.getBoundingClientRect();
      var f = nodes[0].getBoundingClientRect();
      var l = nodes[nodes.length - 1].getBoundingClientRect();
      top = (f.top - t.top) + f.height / 2;
      span = ((l.top - t.top) + l.height / 2) - top;
      track.style.top = top + "px"; track.style.height = span + "px"; progress.style.top = top + "px";
    }
    function update() {
      var t = timeline.getBoundingClientRect();
      var refY = window.innerHeight * 0.62;
      var p = animate ? (refY - (t.top + top)) / span : 1;
      p = Math.max(0, Math.min(1, p));
      progress.style.height = (p * span) + "px";
      nodes.forEach(function (n) { var r = n.getBoundingClientRect(); n.classList.toggle("is-on", animate ? (r.top + r.height/2) < refY + 2 : true); });
      cards.forEach(function (c) { if (!animate || c.getBoundingClientRect().top < window.innerHeight * 0.9) c.classList.add("is-in"); });
    }
    function onResize() { layout(); update(); }
    layout(); update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
    window.addEventListener("load", onResize);
  }
  function boot() { Array.prototype.slice.call(document.querySelectorAll("[data-aspira-journey]")).forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-section"] && !Shopify.designMode) return;
  try {
    
  // Smooth scroll for the scroll hint (only when it's an on-page anchor)
  (function () {
    var root = document.getElementById('vd-hero-{{ section.id }}');
    if (!root) return;

    var link = root.querySelector('.vd-hero__scroll');
    if (!link) return;

    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href') || '';
      if (!href.startsWith('#')) return;

      var target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
